module.exports = __webpack_public_path__ + "img/button-click-collect-corte-ingles.afb94ca9.png";